var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "design-layout-sortable",
    style: {
      right: _vm.isExpand ? "0" : "-278px"
    }
  }, [_vm.show ? _c("div", {
    staticClass: "sortable-aside"
  }, [_c("button", {
    class: {
      active: _vm.show
    },
    on: {
      click: _vm.handle_show_sortable
    }
  }, [_c("i", {
    staticClass: "li-icon li-icon-sortable"
  }), _c("p", [_vm._v(_vm._s(_vm.$t("right.floor")))])])]) : _vm._e(), _c("div", {
    staticClass: "expand",
    class: _vm.isExpand == false ? "arrow-right" : "",
    on: {
      click: _vm.handleExpand
    }
  }, [_c("svg", {
    staticClass: "svg-icon icon panel-icon",
    attrs: {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 86",
      "aria-hidden": "true",
      width: "16",
      height: "86"
    }
  }, [_c("g", {
    attrs: {
      fill: "none",
      "fill-rule": "evenodd"
    }
  }, [_c("path", {
    staticClass: "path-wapper",
    attrs: {
      d: "M0 0l14.12 8.825A4 4 0 0116 12.217v61.566a4 4 0 01-1.88 3.392L0 86V0z",
      fill: "#409EFF"
    }
  }), _c("path", {
    staticClass: "path-arrow",
    attrs: {
      d: "M10.758 48.766a.778.778 0 000-1.127L6.996 43l3.762-4.639a.778.778 0 000-1.127.85.85 0 00-1.172 0l-4.344 5.202a.78.78 0 000 1.128l4.344 5.202a.85.85 0 001.172 0z",
      fill: "#fff",
      "fill-rule": "nonzero"
    }
  })])])]), _c("div", {
    staticClass: "design-layout-sortable-wrapper"
  }, [_c("h2", {
    staticClass: "sortable-head"
  }, [_vm._v(_vm._s(_vm.$t("right.floorManager")))]), _vm.components.length <= 0 ? _c("div", {
    staticClass: "is-empty"
  }, [_c("img", {
    attrs: {
      src: _vm.images.emptySort
    }
  }), _vm._v(" " + _vm._s(_vm.$t("right.empty")) + " ")]) : _c("a-spin", {
    attrs: {
      spinning: _vm.loading
    }
  }, [_c("div", {
    class: {
      "sortable-body": true,
      "in-drag": _vm.inDrag,
      "out-drag": !_vm.inDrag
    }
  }, [_c("div", {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c("span", {
    staticClass: "button-clear-all",
    on: {
      click: function click($event) {
        return _vm.$store.dispatch("design/page_reset");
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("right.clarAll")))])]), _c("draggable", _vm._b({
    attrs: {
      tag: "ul",
      list: _vm.components,
      filter: ".is-disabled",
      move: _vm.onMove
    },
    on: {
      start: function start($event) {
        _vm.inDrag = true;
      }
    }
  }, "draggable", _vm.dragOptions, false), [_c("transition-group", {
    attrs: {
      type: "transition",
      name: !_vm.inDrag ? "flip-list" : null
    }
  }, [_vm._l(_vm.components, function (item, index) {
    return [_c("li", {
      key: item.id,
      class: {
        "in-hover": _vm.inHover == item.id,
        "is-selected": _vm.selected_id == item.id,
        "is-disabled": item.draggable === false
      },
      on: {
        click: function click($event) {
          return _vm.handle_location_component(item, index);
        },
        mousemove: function mousemove($event) {
          _vm.inHover = item.id;
        },
        mouseleave: function mouseleave($event) {
          _vm.inHover = "";
        }
      }
    }, [_c("p", {
      staticStyle: {
        display: "flex",
        "justify-content": "space-between"
      }
    }, [_c("span", {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title || _vm.$t("com.unKnownCom")))]), _c("span", {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(_vm.componentType(item)))])]), _c("div", {
      staticClass: "buttons"
    }, [_c("span", {
      staticClass: "ignore-elements",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.$store.dispatch("design/form_open", item.id);
        }
      }
    }, [_c("a-icon", {
      attrs: {
        type: "form"
      }
    })], 1), _c("span", {
      staticClass: "ignore-elements",
      class: {
        disabled: item.draggable === false
      },
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.$store.dispatch("design/componentDelete", item.id);
        }
      }
    }, [_c("a-icon", {
      attrs: {
        type: "delete"
      }
    })], 1)])])];
  })], 2)], 1)], 1)])], 1), _c("FormPage", {
    attrs: {
      component: _vm.component
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };